import LinkPanelButton, { ILinkPanelButton } from '@creditflowresearch/uilib/LinkPanelButton';
import Flex from '@creditflowresearch/uilib/Flex';

import styles from './linksPanelButton.module.scss';

const LinksPanelButtons = ({ items }: { items: ILinkPanelButton[] }) => (
  <Flex className={ styles.linksContainer }>
    { items.map(
      (item: ILinkPanelButton) => (
        <LinkPanelButton
          key={ item.abbreviation }
          { ...item }
        />
      ),
    ) }
  </Flex>
);

export default LinksPanelButtons;
